import { PrintHouseErp } from "@/enums/print-house-erp";

export const isQuickBooksPrintHouse = (erpType?: number) =>
  erpType === PrintHouseErp.QuickBooks;

/** QB uses indirect tax — system VAT comparison is not meaningful on draft invoices. */
export const shouldShowSystemVatMismatchWarning = (
  erpType?: number,
  pathname?: string,
) =>
  !(isQuickBooksPrintHouse(erpType) && pathname === "/invoice");

export const applyOptimisticTaxCalculating = <T extends Record<string, any>>(
  document: T | null | undefined,
  erpType?: number,
): T | null | undefined => {
  if (!document || !isQuickBooksPrintHouse(erpType)) {
    return document;
  }

  return {
    ...document,
    taxCalculating: true,
    taxComposition: null,
    totalVAT: 0,
    vat: 0,
    totalPayment: document.totalPriceAfterDiscount ?? document.totalPayment ?? 0,
  };
};
